import { api } from '..';

export type DirectoryPersonKind = 'provider' | 'peer-support' | 'member-care';

// These routes are supplied by MYO-2737. Keep the person ID in the URL only
const starPath = (kind: DirectoryPersonKind, id: string) => {
  const segment = encodeURIComponent(id);
  switch (kind) {
    case 'provider':
      return `/v1/therapists/${segment}/star`;
    case 'peer-support':
      return `/v1/organization/my/peer-support/${segment}/star`;
    case 'member-care':
      return `/v1/membercare/organization/my/member-cares/${segment}/star`;
  }
};

export const setDirectoryStar = async (kind: DirectoryPersonKind, id: string, starred: boolean) => {
  const path = starPath(kind, id);
  if (starred) await api.post(path);
  else await api.delete(path);
};
